import MainVideo from "../../components/MainVideo/MainVideo";
import RigthList from "../../components/RigthList/RigthList";
import style from "./styles/MainView.module.css";
import Sign from "../../components/Sign/Sign";
import LeftList from "../../components/LeftList/LeftList";
import Options from "../../components/Options/Options";

interface IMainViewProps {}

const MainView: React.FC<IMainViewProps> = (props) => {
  return (
    <div className={style.background}>
      <div className={style.mainBox}>
        <div className={style.mainCenterBox}>
          <MainVideo />
        </div>
        <div className={style.rigthListBox}>
          <RigthList />
        </div>
      </div>
      {/* <div className={style.mainLeftList}>
                <div className={style.leftListBox}>
                    <LeftList />
                </div>
                <div className={style.mainLeftListBox}>
                    <Sign />
                </div>
            </div>


            <div className={style.mainRigthList}>
                <div className={style.rigthListBox}>
                    <RigthList />
                </div>
                <div className={style.mainRigthListBox}>
                    <Options/>
                </div>
            </div> */}
    </div>
  );
};

export default MainView;
